import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Link } from 'react-router-dom';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCreateUserWithEmailAndPassword, useUpdateProfile, useAuthState } from 'react-firebase-hooks/auth';
import Loading from '../Shared/Loading';
import auth from '../firebase.init';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const SignUp = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [user, loadingUser] = useAuthState(auth);
    const navigate = useNavigate();

    // navigate to home page 
    if (user) {
        navigate('/')
    }


    const [
        createUserWithEmailAndPassword,
        loading
    ] = useCreateUserWithEmailAndPassword(auth, { useSendEmailVerification: true });

    const [updateProfile, updating] = useUpdateProfile(auth);

    const { register, formState: { errors }, handleSubmit, reset } = useForm();

    if (loading || updating || loadingUser) {
        return < Loading />
    }

    const onSubmit = async (data) => {
        setEmail(data?.email);
        setPassword(data?.password);
        setConfirmPassword(data?.cpassword);


        if (password === confirmPassword) {
            setPasswordError('')
            await createUserWithEmailAndPassword(email, password);
            await updateProfile({ displayName: data.name });

            if (email === data?.email) {
                fetch('https://stark-wildwood-35883.herokuapp.com/admin', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ email })
                })
                    .then(res => res.json())
                    .then(data => {
                        if(data?.acknowledged === true){
                            toast.success('Create a new account!!')
                        }
                    });

                reset()
            }

        }
        else {
            setPasswordError(`Your password and confirm password don't match!!!`)
        }

    }



    return (
        <div className='flex items-center justify-center   h-screen'>
            <div className="card mx-auto md:w-96 w-5/6 bg-base-100  shadow-xl">
                <div className="card-body">
                    <h2 className='uppercase text-center font-bold text-2xl mb-4'>Sign Up</h2>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-control w-full ">
                            <input
                                type="text"
                                placeholder="Name"
                                className="input input-bordered w-full"
                                {...register("name", {
                                    required: {
                                        value: true,
                                        message: "Name is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.name?.type === 'required' && <span className="label-text-alt text-red-500">{errors.name.message}</span>}
                            </label>

                            <input
                                type="email"
                                placeholder="Email"
                                className="input input-bordered w-full  "
                                {...register("email", {
                                    required: {
                                        value: true,
                                        message: "Email is required"
                                    },
                                    pattern: {
                                        value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                                        message: "Provide a valid Email!"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.email?.type === 'required' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                                {errors.email?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                            </label>

                            <input
                                type="password"
                                placeholder="Password"
                                className="input input-bordered w-full  "
                                {...register("password", {
                                    required: {
                                        value: true,
                                        message: "Password is required"
                                    },
                                    pattern: {
                                        value: /[0-9a-zA-Z]{6,}/,
                                        message: "Password should 6 characters or longer!"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.password?.type === 'required' && <span className="label-text-alt text-red-500">{errors.password.message}</span>}
                                {errors.password?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.password.message}</span>}
                            </label>

                            <input
                                type="password"
                                placeholder="Confirm Password"
                                className="input input-bordered w-full  "
                                {...register("cpassword", {
                                    required: {
                                        value: true,
                                        message: "Confirm Password is required"
                                    },
                                    pattern: {
                                        value: /[0-9a-zA-Z]{6,}/,
                                        message: "Enter Confirm Password"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.cpassword?.type === 'required' && <span className="label-text-alt text-red-500">{errors.cpassword.message}</span>}
                                {errors.cpassword?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.cpassword.message}</span>}
                                <span className='text-red-500 text-sm '>{passwordError}</span>
                            </label>

                        </div>
                        <button type='submit' className='btn w-full border-0 text-white bg-green-500' >Sign Up <FontAwesomeIcon className='ml-2' icon={faArrowRight}></FontAwesomeIcon> </button>
                        <div className='mt-3'>
                            <span className='text-md mt-5  text-gray-500'>Already have an Account? <span className='text-green-500'><Link to='/mother' >Sing In</Link></span></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignUp;